<script setup lang="ts">
import { useOfflineMode } from '@/composables/useOfflineMode';

const { isOffline } = useOfflineMode();
</script>

<template>
  <Teleport to="body">
    <Transition name="offline-banner">
      <div v-if="isOffline" class="offline-banner" role="alert">
        <i class="bi bi-wifi-off me-2" />
        <span>You are offline — viewing cached data in read-only mode.</span>
      </div>
    </Transition>
  </Teleport>
</template>

<style scoped>
.offline-banner {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 10000;
  background: #dc3545;
  color: #fff;
  text-align: center;
  padding: 6px 16px;
  font-size: 13px;
  font-weight: 500;
  letter-spacing: 0.01em;
}

.offline-banner-enter-active {
  animation: offline-slide-down 0.3s ease-out;
}

.offline-banner-leave-active {
  animation: offline-slide-up 0.2s ease-in forwards;
}

@keyframes offline-slide-down {
  from {
    opacity: 0;
    transform: translateY(-100%);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes offline-slide-up {
  from {
    opacity: 1;
    transform: translateY(0);
  }
  to {
    opacity: 0;
    transform: translateY(-100%);
  }
}
</style>
